import { META_ID } from "@/configs/analytics"
import Cookies from "js-cookie";
class MetaPixel {
    constructor(metaId = META_ID) {
        this.META_ID = metaId;
        if (!this.META_ID) {
            return
        }
        this.loadFacebookPixel()
    }
    loadFacebookPixel() {
        // <!-- Meta Pixel Code -->
        !function (f, b, e, v, n, t, s) {
            if (f.fbq) return; n = f.fbq = function () {
                n.callMethod ?
                    n.callMethod.apply(n, arguments) : n.queue.push(arguments)
            };
            if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
            n.queue = []; t = b.createElement(e); t.async = !0;
            t.src = v; s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s)
        }(window, document, 'script',
            'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', this.META_ID);
        fbq('track', 'PageView');

        this.checkFromSource()
        // <!-- End Meta Pixel Code -->
    }
    // Ref: https://developers.facebook.com/docs/meta-pixel/reference#standard-events
    trackAddToCart(ids = [], name = "", type = "", contents = [], currency = "", value = 0) {
        let fromSources = Cookies.get("lora-from-sources") || "{}";
        fromSources = JSON.parse(fromSources)
        fbq('trackSingle', this.META_ID, 'AddToCart', {
            content_ids: ids,
            content_name: name,
            content_type: type,
            contents: contents,
            currency: currency,
            value: value,
            from_sources: fromSources
        });
    }
    trackPurchase(ids = [], name = "", type = "", contents = [], currency = "", numItems = 0, value = 0) {
        let fromSources = Cookies.get("lora-from-sources") || "{}";
        fromSources = JSON.parse(fromSources)
        fbq('trackSingle', this.META_ID, 'Purchase', {
            content_ids: ids,
            content_name: name,
            content_type: type,
            contents: contents,
            currency: currency,
            num_items: numItems,
            value: value,
            from_sources: fromSources
        });
        Cookies.remove("lora-from-sources")
    }
    trackClickCheckoutBtn(ids = [], name = "", type = "", contents = [], currency = "", numItems = 0, value = 0) {
        let fromSources = Cookies.get("lora-from-sources") || "{}";
        fromSources = JSON.parse(fromSources)
        fbq('trackSingleCustom', this.META_ID, 'ClickCheckOutBtn', {
            content_ids: ids,
            content_name: name,
            content_type: type,
            contents: contents,
            currency: currency,
            num_items: numItems,
            value: value,
            from_sources: fromSources
        });
    }
    trackCheckoutFail(ids = [], name = "", type = "", contents = [], currency = "", numItems = 0, value = 0) {
        let fromSources = Cookies.get("lora-from-sources") || "{}";
        fromSources = JSON.parse(fromSources)
        fbq('trackSingleCustom', this.META_ID, 'CheckOutFailed', {
            content_ids: ids,
            content_name: name,
            content_type: type,
            contents: contents,
            currency: currency,
            num_items: numItems,
            value: value,
            from_sources: fromSources
        });
    }

    checkFromSource() {
        const params = new URLSearchParams(window.location.search);
        let vid = ""
        let pid = ""
        let orgId = ""
        if (params.has('vid')) {
            vid = params.get('vid')
        }
        if (params.has('pid')) {
            pid = params.get('pid')
        }
        if (params.has('orgid')) {
            orgId = params.get('orgid')
        }
        let fromSourcesRaw = Cookies.get("lora-from-sources") || "{}";
        let fromSources = JSON.parse(fromSourcesRaw)
        // Check in array
        const exists = fromSources.video_id === vid && fromSources.playlist_id === pid;
        if (vid && !exists) {
            fromSources = {
                video_id: vid,
                playlist_id: pid,
                organization_id: orgId
            }
            Cookies.set("lora-from-sources", JSON.stringify(fromSources));
        }
    }
}

export {
    MetaPixel
};